import { useEffect, useState, type ReactElement } from "react";
import { RootState } from "src/app/store";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "src/app/store";
import { Admin } from "src/features/admin";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import LogoutModal from "src/features/authentication/components/LogoutModal";
import { logoutUser } from "src/features/authentication/hooks/userAuth";
import { getDealers } from "src/features/admin/hooks/dealers";
import Spinner from "src/components/Spinner";

export interface AdminHomeProps {

}

export function AdminHomePage(props: AdminHomeProps): ReactElement {
        const navigate = useNavigate();
        const { authUser } = useSelector((state: RootState) => state.auth);
        const [showLogoutModal, setShowLogoutModal] = useState(false);
        const dispatch = useDispatch<AppDispatch>();

        const onIdle = () => {
                if (showLogoutModal) {
                        dispatch(logoutUser(authUser));
                }
                setShowLogoutModal(false);
        }

        const staySignedIn = () => {
                setShowLogoutModal(false);
                reset();
        }

        const onPrompt = () => {
                setShowLogoutModal(true);
        }

        const { getRemainingTime, reset } = useIdleTimer({
                onIdle,
                onPrompt,
                timeout: 1000 * 60 * 8,
                promptBeforeIdle: 1000 * 60 * 3,
                debounce: 500
        })

        // useEffect(() => {
        // 	dispatch(getDealers(""));
        // }, [])

        return <>
                <Admin />
                {showLogoutModal ?
                        <LogoutModal title="Logout Modal" isOpen={showLogoutModal} onClose={staySignedIn} />
                        :
                        <></>
                }
        </>
}			
